
// CONFIG FOR SHOPIFY

var fullSiteRoot = 'https://gx1000.com';

// environment

gx1000Config.fullSiteRoot = fullSiteRoot;

gx1000Config.shopBaseURL = fullSiteRoot;

// cart

gx1000Config.cartAjaxEnabled = true;

gx1000Config.fakeCartAjax = false;
gx1000Config.cartDataBaseURL = fullSiteRoot;

gx1000Config.miniCartCheckoutURL = fullSiteRoot + '/checkout';
gx1000Config.miniCartViewCartURL = fullSiteRoot + '/cart';

// urls

gx1000Config.collectionURL = fullSiteRoot + '/collections/{collection_slug}';
gx1000Config.collectionProductURL = fullSiteRoot + '/collections/{collection_slug}/products/{product_slug}';
gx1000Config.productURL = fullSiteRoot + '/products/{product_slug}';
gx1000Config.pageURL = fullSiteRoot + '/pages/{page_slug}';
gx1000Config.articleURL = fullSiteRoot + '/blogs/{blog_slug}/{article_slug}';